export enum CustomFieldTypeEnum {
    input = 'input',
    // select = 'select', // доработать выпадающий список если потребуется в компоненте кастомных полей
    textarea = 'textarea',
    checkbox = 'checkbox',
    toggle = 'toggle',
}
